import type { PerfilVeiculo } from '../../dominio/didatico/perfilVeiculo'
import { MaterialPeca, Peca } from '../componentes/Peca'
import { Rotulo3D } from '../componentes/Rotulo3D'
import { usePeca } from '../componentes/contextoMaquete'
import { CaixaArredondada } from '../componentes/CaixaArredondada'

/** Representação didática da bateria; a posição real deve vir da ficha do veículo. */
export function Bateria12V({ perfil }: { perfil: PerfilVeiculo }) {
  const aparencia = usePeca('bateria12v')
  const z = perfil.colunaA.zBase + (perfil.frenteZ - perfil.colunaA.zBase) * 0.42
  return (
    <Peca id="bateria12v" deslocamentoAfastado={[0, 0.55, 0]}>
      <group position={[-perfil.largura * 0.22, perfil.capoY - 0.24, z]}>
        <mesh>
          <CaixaArredondada args={[0.34, 0.23, 0.48]} />
          <MaterialPeca id="bateria12v" corBase="#20272c" rugosidade={0.82} />
        </mesh>
        <Terminal x={-0.1} cor="#252b30" />
        <Terminal x={0.1} cor="#d84b43" />
        {aparencia.selecionada && (
          <Rotulo3D posicao={[0, 0.48, 0]} texto="− primeiro · + depois" variante="zona" fator={4.2} />
        )}
      </group>
    </Peca>
  )
}

function Terminal({ x, cor }: { x: number; cor: string }) {
  return (
    <mesh position={[x, 0.135, 0.13]}>
      <cylinderGeometry args={[0.035, 0.045, 0.05, 12]} />
      <meshStandardMaterial color={cor} metalness={0.45} roughness={0.42} />
    </mesh>
  )
}
